var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", [
        _vm.active == 0
          ? _c("div", [
              _c("div", { staticClass: "page" }, [
                _c(
                  "div",
                  { staticClass: "top" },
                  [
                    _c("van-image", {
                      attrs: {
                        width: "54",
                        height: "54",
                        src: _vm.userInfo.avatar,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "error",
                            fn: function () {
                              return [_vm._v("加载失败")]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        1393410444
                      ),
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "text" }, [
                  _c("div", [_vm._v(_vm._s(_vm.userInfo.nickName))]),
                  _c("div", { staticClass: "text-bottom" }, [
                    _vm._v(_vm._s(_vm.userInfo.dept.deptName)),
                  ]),
                ]),
              ]),
              _c(
                "div",
                {
                  ref: "myDiv",
                  staticClass: "p-l-10 p-r-10 p-b-26",
                  staticStyle: { "padding-top": "2.8rem" },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "page-content",
                      staticStyle: { "margin-top": "0" },
                    },
                    [
                      _c("div", { staticClass: "title" }, [_vm._v("看板")]),
                      _c(
                        "van-row",
                        _vm._l(_vm.boardList, function (item, index) {
                          return _c(
                            "van-col",
                            {
                              key: index,
                              attrs: { span: "6" },
                              on: {
                                click: function ($event) {
                                  return _vm.goPageKeep(item.path, index)
                                },
                              },
                            },
                            [
                              _c("van-badge", [
                                _c("img", {
                                  staticClass: "icon",
                                  attrs: { src: item.iconSrc },
                                }),
                              ]),
                              _c("div", { staticClass: "icon-text" }, [
                                _vm._v(_vm._s(item.text)),
                              ]),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "page-content" },
                    [
                      _c("div", { staticClass: "title" }, [_vm._v("我的工作")]),
                      _c(
                        "van-row",
                        _vm._l(_vm.workIconList, function (item, index) {
                          return _c(
                            "van-col",
                            {
                              key: index,
                              attrs: { span: "6" },
                              on: {
                                click: function ($event) {
                                  return _vm.goPageKeep(item.path, index)
                                },
                              },
                            },
                            [
                              _c("van-badge", [
                                _c("img", {
                                  staticClass: "icon",
                                  attrs: { src: item.iconSrc },
                                }),
                              ]),
                              _c("div", { staticClass: "icon-text" }, [
                                _vm._v(_vm._s(item.text)),
                              ]),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "page-content" },
                    [
                      _c("div", { staticClass: "title" }, [_vm._v("日常办公")]),
                      _c(
                        "van-row",
                        _vm._l(_vm.examineList, function (item, index) {
                          return _c(
                            "van-col",
                            {
                              key: index,
                              attrs: { span: "6" },
                              on: {
                                click: function ($event) {
                                  return _vm.goPage(item)
                                },
                              },
                            },
                            [
                              _c("van-badge", [
                                _c("img", {
                                  staticClass: "icon",
                                  attrs: { src: item.examineIcon },
                                }),
                              ]),
                              _c("div", { staticClass: "icon-text" }, [
                                _vm._v(_vm._s(_vm.dataSize[item.groupId])),
                              ]),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "page-content" },
                    [
                      _c("div", { staticClass: "title" }, [_vm._v("项财CRM")]),
                      _c(
                        "van-row",
                        _vm._l(_vm.itemMaterialList, function (item, index) {
                          return _c(
                            "van-col",
                            {
                              key: index,
                              attrs: { span: "6" },
                              on: {
                                click: function ($event) {
                                  return _vm.goPageKeep(item.path)
                                },
                              },
                            },
                            [
                              _c("van-badge", [
                                _c("img", {
                                  staticClass: "icon",
                                  attrs: { src: item.iconSrc },
                                }),
                              ]),
                              _c("div", { staticClass: "icon-text" }, [
                                _vm._v(_vm._s(item.text)),
                              ]),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "page-content" },
                    [
                      _c("div", { staticClass: "title" }, [_vm._v("其他")]),
                      _c(
                        "van-row",
                        _vm._l(_vm.otherList, function (item, index) {
                          return _c(
                            "van-col",
                            {
                              key: index,
                              attrs: { span: "6" },
                              on: {
                                click: function ($event) {
                                  return _vm.goPageKeep(item.path)
                                },
                              },
                            },
                            [
                              _c("van-badge", [
                                _c("img", {
                                  staticClass: "icon",
                                  attrs: { src: item.iconSrc },
                                }),
                              ]),
                              _c("div", { staticClass: "icon-text" }, [
                                _vm._v(_vm._s(item.text)),
                              ]),
                            ],
                            1
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ])
          : _vm._e(),
        _vm.active == 1 ? _c("div", [_c("myWork")], 1) : _vm._e(),
      ]),
      _c(
        "van-tabbar",
        {
          attrs: {
            fixed: "",
            placeholder: true,
            "safe-area-inset-bottom": true,
          },
          on: { change: _vm.onChange },
          model: {
            value: _vm.active,
            callback: function ($$v) {
              _vm.active = $$v
            },
            expression: "active",
          },
        },
        [
          _c("van-tabbar-item", { attrs: { icon: "home-o" } }, [
            _vm._v("首页"),
          ]),
          _c("van-tabbar-item", { attrs: { icon: "apps-o" } }, [
            _vm._v("我的工作"),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }